import {create} from 'zustand';
import type {CheckoutState} from '@chekin/shared/payments';

type PaymentFlowRequest = CheckoutState & {
  paymentId?: string;
  from?: string;
  redirectAfterPaidPath?: string;
};

type PaymentFlowStore = {
  request: PaymentFlowRequest | null;
  open: (request: PaymentFlowRequest) => void;
  close: () => void;
};

export const usePaymentFlowStore = create<PaymentFlowStore>(set => ({
  request: null,
  open: request => set({request}),
  close: () => set({request: null}),
}));

export type {PaymentFlowRequest};
